<template>
  <div>
    <!-- ランキング -->
    <section class="section">
      <h2 class="sub-title">
        {{ Ranking.all[lang] }}
      </h2>
      <select
        class="ranking-pulldown"
        id="ranking-pulldown"
        @change="onChange()"
        v-model="activeIndex"
      >
        <option
          v-for="(rankingName, index) in rankingNameList"
          :key="index"
          class="ranking-option"
          :value="index"
          >{{ rankingName.text[lang] }}</option
        >
      </select>
      <!-- 対象外 または ランキングデータが空 の時はランキングを表示しない。 -->
      <div v-if="!isExcludedRanking && !isEmpty">
        <TeamStatus
          :is-loading-ranking="isLoadingRanking"
          :is-not-found="isNotFound"
          :is-server-error="isServerError"
          :is-initial-ranking-data="isInitialRankingData"
          :event-status="eventStatus"
          :count-total-runner="0"
          :event-date-at="eventDateAt"
          @initial-ranking="initialRanking"
        ></TeamStatus>
        <!-- ページング  -->
        <v-pagination
          v-if="!isLoadingRanking && !isNotFound && !isServerError"
          v-model="$page.current"
          v-bind:length="$page.total"
          v-bind:total-visible="$page.visible"
          color="#0093e6"
          class="rank-pagination"
        ></v-pagination>
        <!-- ランキングリスト（1位~100位） -->
        <TeamRankingList
          v-if="!isLoadingRanking && !isNotFound && !isServerError"
          :lang="lang"
          :lang-path="langPath"
          :ranking="TeamRanking"
          :data-event-ranking="dataEventRanking"
          :data-event-summary="dataEventSummary"
          :data-ranking="dataRanking"
          :event-status="eventStatus"
          :is-foreign-country="isForeignCountry"
          :nass-event-id="nassEventId"
        ></TeamRankingList>
        <!-- ページング  -->
        <v-pagination
          v-if="!isLoadingRanking && !isNotFound && !isServerError"
          v-model="$page.current"
          v-bind:length="$page.total"
          v-bind:total-visible="$page.visible"
          color="#0093e6"
          class="rank-pagination"
        ></v-pagination>
      </div>
      <div v-if="isExcludedRanking" class="hidden-ranking-message">
        {{ Ranking.excludedRanking1[lang] }}
        {{ tabNameList[this.activeIndex].text[lang] }}
        {{ Ranking.excludedRanking2[lang] }}
      </div>
      <div v-else-if="isEmpty" class="hidden-ranking-message">
        {{ Ranking.emptyRanking[lang] }}
      </div>

      <hr class="width-line" />

      <!-- 個人記録検索  -->
      <PersonalDataSearch></PersonalDataSearch>
    </section>
  </div>
</template>

<script>
import TeamRanking from "../../../../assets/constants/company/ranking/teamRanking.json";
import { RepositoryFactory } from "../../../../api/RepositoryFactory";
import Ranking from "../../../../assets/constants/ranking/ranking.json";
import Loading from "../../Loading";
import BadRequest from "../../../common/status/BadRequest";
import InternalServerError from "../../../common/status/InternalServerError";
import TeamStatus from "./TeamStatus";
import PersonalDataSearch from "./PersonalDataSearch";
import TeamRankingList from "./TeamRankingList";

export default {
  props: {
    dataEventRanking: Object,
    dataEventSummary: Object,
    isForeignCountry: Boolean,
  },
  data() {
    return {
      isLoadingRanking: true,
      isBadRequest: false,
      isNotFound: false,
      isServerError: false,
      isInitialRankingData: false,
      isEmpty: false,
      selectGender: "",
      selectAge: "",
      selectCountry: "",
      selectBranch: "",
      selectDepartment: "",
      selectAffiliation: "",
      dataRanking: null,
      nassEventId: "",
      eventStatus: "",
      countTotalTeam: 0,
      eventDateAt: "",
      teamRanking: {},
      tabNameList: [],
      rankingNameList: [],
      activeIndex: 0, // 表示するランキングのindex
      isExcludedRanking: true, // 選択中のランキングが表示可能か,
      options: [],
    };
  },
  async created() {
    // イベントID取得
    this.nassEventId = sessionStorage.getItem("nassEventId");
    // プルダウン
    const hasRegulatedDistance =
      this.dataEventSummary.summary.has_regulated_distance; // 規定距離の有無を取得
    this.teamRanking = hasRegulatedDistance
      ? TeamRanking.fixed_distance
      : TeamRanking.unlimited_distance;
    this.tabNameList = this.teamRanking.tab_list;
    this.rankingNameList = this.teamRanking.tab_list;
    this.activeIndex = this.teamRanking.initial_active_index;
    // ランキング取得
    await this.initialRanking();
  },
  mounted() {
    this.options = document.getElementById("ranking-pulldown").options;
    this.options[this.activeIndex].selected = true;
  },
  methods: {
    /**
     * 初回検索
     */
    initialRanking: async function () {
      // 条件初期化
      this.initialConditions();

      // 通信
      await this.fetchRanking(false);

      // 「〇〇人見つかりました」はinitialの時は表示しない
      this.isInitialRankingData = false;
    },

    /**
     * コンポーネントの状態とデータの初期化
     */
    initialConditions: function () {
      this.isLoadingRanking = true;
      this.isNotFound = false;
      this.isServerError = false;
      this.dataRanking = null;
      this.countTotalTeam = 0;
      this.isExcludedRanking = false;
      this.isEmpty = false;
    },

    /**
     * プルダウン押下時の処理
     */
    onChange: async function () {
      // 対象外のランキングか
      if (this.tabNameList[this.activeIndex].is_excluded) {
        this.isExcludedRanking = true;
        return;
      }
      this.initialConditions();
      await this.fetchRanking(false);
    },

    /**
     * 通信部分共通
     */
    fetchRanking: async function (isOffsetInitial) {
      const param = {
        nass_event: this.nassEventId,
        sort: this.rankingNameList[this.activeIndex].sort,
        offset: isOffsetInitial ? 0 : (this.$route.query.page - 1) * 100,
        limit: 100,
      };

      try {
        const RankingRepository = RepositoryFactory.get("ranking");
        const response = await RankingRepository.getTeamRanking(param);
        this.dataRanking = response.data;

        // 総件数（paging用と表示用）
        this.$page.rows = response.data.team_ranking.meta_data.total_count;
        this.countTotalTeam = response.data.team_ranking.meta_data.total_count;

        // イベントステータス（'0'か'100'）
        this.eventStatus = response.data.team_ranking.meta_data.status;

        // イベント開催日
        this.eventDateAt = response.data.event_date_at[this.lang];

        // 「〇〇人見つかりました」はinitialの時は表示しない
        this.isInitialRankingData = true;

        // ランナー0の時はランキングを表示しない。
        if (response.data.team_ranking.company_contents.length === 0) {
          this.isEmpty = true;
        }

        // ページ数をセット
        this.$page.current = isOffsetInitial ? 1 : this.$route.query.page;
      } catch (e) {
        if (e.response.status === 404) {
          this.$page.rows = 0;
          this.isNotFound = true;
        } else {
          this.isServerError = true;
        }
      } finally {
        this.isLoadingRanking = false;
      }
    },
  },
  computed: {
    Ranking: function () {
      return Ranking;
    },
    TeamRanking: function () {
      return TeamRanking;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  watch: {
    "$page.current": function (newNumber) {
      this.$router.push(
        {
          name: this.name,
          query: {
            event: this.$route.query.event,
            page: newNumber,
          },
        },
        () => {
          this.fetchRanking(false);
        }
      );
    },
  },
  components: {
    Loading,
    BadRequest,
    InternalServerError,
    TeamStatus,
    TeamRankingList,
    PersonalDataSearch,
  },
  name: "TeamRankingContents",
};
</script>

<style scoped>
.section {
  margin: 42px 0 0 0;
}

.rank-pagination {
  margin: 40px 0 0 0;
}

.ranking-pulldown {
  width: 100%;
  height: 45px;
  color: #000;
  margin: 25px 0 15px;
  padding: 0 0 0 15px;
  border-radius: 6px;
  border: solid 1px #000;
  font-size: 18px;
  background-image: url("../../../../assets/images/arrow-down.svg");
  background-position: right 19px center;
  background-repeat: no-repeat;
  background-size: 14px 7px;
}

.hidden-ranking-message {
  text-align: center;
  background-color: var(--defaultGrayColor);
  border-radius: 6px;
  padding: 50px 25px;
  margin: 20px 0 0 0;
}

.width-line {
  margin: 40px 0 0 0;
  width: 100%;
  border-top: solid 1px #000;
}
</style>



// WEBPACK FOOTER //
// src/components/sp/company/ranking/TeamRankingContents.vue